
import { determineVatRate } from "./utils";
import { EuropeanCountryCodes } from './configData';

import { getBillingItems } from '../api/billingItems';
import { getTypeOfGoods } from '../api/typeOfGoods';

import { generateId } from './utils';
import { Currencies } from './configData';


const taxationAutoForCurrentSelectedService = ({ dataShipement, data, priceForTypeOfGoods, option, auto = false }) => {

    // totalHandlingUnits
    // soWeight
    // soChargeableWeight
    // soVolume

    const VAT = determineVatRate({
        orderingParty: dataShipement.orderingParty,
        consignor: dataShipement.consignor,
        consignee: dataShipement.consignee,
        EuropeanCountryCodes
    });

    data.clientUnitPrice = option?.unitPrice || 0


    if (option.code === "21") {  // Manutention & traitement de colis
        data.quantity = dataShipement.totalHandlingUnits;
        data.unit = option.unit;
        data.clientUnitPrice = option.unitPrice || 0

    }
    else if (option.code === "40") { // Acheminement
        data.quantity = dataShipement.soWeight;
        data.unit = option.unit;
        data.clientUnitPrice = priceForTypeOfGoods || 0

    }
    else if (option.code === "50") { // Assurance
        data.unit = option.unit;
        data.quantity = 1

        if (dataShipement.declaredValue * option.unitPrice < option.unitPriceMin) {
            data.clientUnitPrice = option.unitPriceMin
        }
        else {
            data.clientUnitPrice = Math.ceil(option.unitPrice * dataShipement.declaredValue);
        }
    } 

    data.clientVATRate = VAT.vatRate?.rate || 0;

    
    auto && (data.clientTotalHT = data.quantity * data.clientUnitPrice); // If auto, set manual calculation to true
    

    if (option.code === "50" && dataShipement.declaredValue === 0){
        data.clientUnitPrice = 0;
        data.clientTotalHT = 0;
    } 
    if (option.code === "40" && data.clientTotalHT <= 100) data.clientTotalHT = option.unitPriceMin;

    return data

}


function createNewServiceItem(item, dataShipement) {
    // If item is provided (for default items), use its values, else use default values
    return {
        _id: generateId(),
        shipmentOrderCode: item?.shipmentOrderCode || (typeof dataShipement !== "undefined" && dataShipement.shipmentOrderCode) || '',
        itemCode: item?.itemCode ?? null,
        designation: item?.designation
            ? { en: item.designation.en, fr: item.designation.fr }
            : {},
        quantity: item?.quantity || 1, // Default quantity
        unit: item?.unit ?? 'FIX', // Default unit, can be changed later
        isManualCalculation: false,

        client: item?.client || dataShipement.orderingParty || {},
        clientInvoiceNumber: null,

        clientUnitPrice: 0,
        clientCurrency: Currencies[0].key, // Default to EUR
        clientVAT: 0,
        clientVATRate: 0,
        clientTotalHT: 0,
        clientDiscountRate: 0,
        clientDiscountAmount: 0,

        supplier: {},
        supplierInvoiceNumber: null,
        supplierUnitPrice: 0,
        supplierCurrency: Currencies[0].key, // Default to EUR
        supplierVAT: 0,
        supplierVATRate: 0,
        supplierTotalHT: 0,
        supplierDiscountRate: 0,
        supplierDiscountAmount: 0,
    };
}


const taxationAutomaticForShipement = async ({ dataShipement, setDataServiceList, setDataShipement }) => {

    let serviceListItems = []

    let items = await getBillingItems({})
    let priceForTypeOfGoods = await getTypeOfGoods({ code: dataShipement.goodsDescription }).then(rs => {
        if (rs) {
            let p = rs.filter(item => item.key === dataShipement.goodsDescription)
            if (p.length === 0) {
                p = 0
            }
            else {
                p = p[0].unitPrice
            }
            return p
        }
    });


    const handleClientSelect = ({ dataShipement, data, priceForTypeOfGoods, option }) => {

        const newData = taxationAutoForCurrentSelectedService({
            dataShipement, data, priceForTypeOfGoods, option, auto: true
        });

        serviceListItems.push({ ...newData, itemCode: option.code, designation: { fr: option.designationFr, en: option.designationEn }, bI: option });
    }

    handleClientSelect({ dataShipement, data: createNewServiceItem({}, dataShipement), priceForTypeOfGoods, option: items.find(item => item.code === "40") }); // Acheminement

    handleClientSelect({ dataShipement, data: createNewServiceItem({}, dataShipement), priceForTypeOfGoods, option: items.find(item => item.code === "21") }); // Manutention & traitement de colis

    handleClientSelect({ dataShipement, data: createNewServiceItem({}, dataShipement), priceForTypeOfGoods, option: items.find(item => item.code === "32") }); // Frais de dossier export

    handleClientSelect({ dataShipement, data: createNewServiceItem({}, dataShipement), priceForTypeOfGoods, option: items.find(item => item.code === "50") }); // Assurance



    setDataServiceList(serviceListItems);

    calculateTotalsSummaryForShipement({ list: serviceListItems, setDataShipement });



}

const calculateTotalsSummaryForShipement = ({ list, setDataShipement }) => {
    const calculateTotalsSummary = (list) => {
        return list.reduce(
            (acc, item) => {
                acc.revenue += item.clientTotalHT || 0;
                acc.cost += item.supplierTotalHT || 0;
                return acc;
            },
            { revenue: 0, cost: 0 }
        );
    };

    const { revenue, cost } = calculateTotalsSummary(list);
    setDataShipement(prev => ({
        ...prev,
        revenue: parseFloat(revenue.toFixed(2)),
        cost: parseFloat(cost.toFixed(2)),
        commercialMargin: parseFloat((revenue - cost).toFixed(2)),
    }));
}



export { taxationAutoForCurrentSelectedService, taxationAutomaticForShipement, createNewServiceItem, calculateTotalsSummaryForShipement };